import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Plus, Minus } from 'lucide-react';
import { SectionHeading } from './ui-kit/SectionHeading';
import { Reveal } from './ui-kit/Reveal';

const FAQ = () => {
  const { t } = useLanguage();
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="bg-surface-muted py-24 md:py-32" data-testid="faq-section">
      <div className="container-page grid md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <SectionHeading
            eyebrow="UKK"
            title={t.faq.title}
            lead={t.faq.subtitle}
          />
        </div>

        <div className="md:col-span-8">
          <ul className="divide-y divide-line border-y border-line">
            {t.faq.items.map((item, i) => {
              const isOpen = openIdx === i;
              return (
                <Reveal as="li" key={item.question} delay={i * 50}>
                  <button
                    type="button"
                    onClick={() => setOpenIdx(isOpen ? -1 : i)}
                    className="w-full flex items-center justify-between gap-6 py-6 text-left group"
                    aria-expanded={isOpen}
                    data-testid={`faq-item-${i}`}
                  >
                    <span className="text-[17px] md:text-[18px] font-medium text-ink leading-snug pr-4">
                      {item.question}
                    </span>
                    <span
                      className={
                        'inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-pill border border-line transition-colors ' +
                        (isOpen ? 'bg-ink text-white border-ink' : 'text-ink-muted group-hover:border-ink group-hover:text-ink')
                      }
                    >
                      {isOpen ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                    </span>
                  </button>
                  <div
                    className="overflow-hidden transition-[max-height,opacity] duration-300 ease-out-quart"
                    style={{ maxHeight: isOpen ? 320 : 0, opacity: isOpen ? 1 : 0 }}
                    aria-hidden={!isOpen}
                  >
                    <p className="pb-6 pr-12 text-body text-ink-muted max-w-3xl">
                      {item.answer}
                    </p>
                  </div>
                </Reveal>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
